import {Component, OnInit} from '@angular/core';
import {Service} from "../../../Models/service";
import {ActivatedRoute} from "@angular/router";
import {ServiceService} from "../../../Services/service.service";

@Component({
  selector: 'app-category-details',
  templateUrl: './category-details.component.html',
  styleUrls: ['./category-details.component.scss']
})
export class CategoryDetailsComponent  implements OnInit {
categoryId = 0;
  constructor(private activatedRoute: ActivatedRoute, private servicesService: ServiceService) { }

  ngOnInit(): void {
      this.categoryId = +this.activatedRoute.snapshot.paramMap.get('id') ;
  }

}
